import { createBrowserHistory } from 'history';
import { AppInsights } from 'applicationinsights-js';

const history = createBrowserHistory();
history.listen(location => {
  AppInsights.trackPageView(location.pathname);
  window.scrollTo(0, 0);
});
export default history;
